module.exports = __webpack_public_path__ + "img/18.3e4ca10d.jpeg";